var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgClaims = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 75,
    viewBox: "0 0 84 75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#89B6DE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.352 54.98V8.872c.001-2.291.913-4.488 2.536-6.105C13.51 1.149 15.708.243 18 .248h52.136M61.6 9.436V62.2c0 4.765-3.863 8.628-8.628 8.628H18",
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.96 62.9c.002-3.9 2.843-7.217 6.696-7.82-.406-.067-.817-.102-1.228-.104H8.124c-4.308.097-7.75 3.617-7.75 7.926 0 4.31 3.442 7.83 7.75 7.926h41.304c.412-.003.822-.04 1.228-.108-3.854-.601-6.695-3.92-6.696-7.82h0zM70.664.2c-4.993 0-9.04 4.047-9.04 9.04h18.084c0-2.398-.953-4.698-2.65-6.394C75.364 1.151 73.063.2 70.665.2h0zM17.392 10.496h32.612M17.392 19.296h32.612M17.392 28.096h32.612M17.392 36.896h32.612M17.392 45.696h32.612",
    transform: "translate(2 2)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgClaims, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/claims.74081085.svg";
export { ForwardRef as ReactComponent };